// src/components/pages/sports/Partials/FacilitySection.jsx
import React from 'react';
import Slider from 'react-slick';

const FacilitySection = ({ facilitySection }) => {
  if (!facilitySection) return <></>;

  const mobileCarouselSettings1 = {
    infinite: true,
    speed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    rtl: true
  };

  const mobileCarouselSettings2 = { ...mobileCarouselSettings1, rtl: false };

  const sportsItems = (facilitySection.sports_icons || []).map(item => ({
    img: `${process.env.REACT_APP_API_URL}/public${item.image_url}`,
    label: item.label
  }));

  return (
    <section className="facility">
      <div className="container">
        <div className="row">
          <div className="sec-title text-center"><h2>{facilitySection.heading || "FACILITIES"}</h2></div>
        </div>

        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-8 col-12">
            <h6 className="text-center mb-3 ">{facilitySection.list_heading || 'FACILITIES AND PROGRAMMES OF THE DEPARTMENT'}</h6>
            <ul className="vision-list">
              {Object.values(facilitySection.list_points || {}).map((pt, i) => (
                <li key={i} >
                  <i className={`fa ${pt.icon_class || 'fa-hand-o-right'}`}></i> {pt.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-md-4 col-12">
            <table className="timings-table">
              <thead>
                <tr><th colSpan="2">Sports Facilities Timings</th></tr>
              </thead>
              <tbody>
                {(facilitySection.timings || []).map((t, idx) => (
                  <tr key={idx}>
                    <td>{t.label}</td>
                    <td>{t.time_range}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row ">
          <div className="sec-title text-center"><h2>{facilitySection.events_heading || 'THE SPORTS COMPRISES OF THE FOLLOWING EVENTS'}</h2></div>
        </div>

        <div className="container d-none d-md-block">
          <div className="row">
            {sportsItems.map((item, index) => (
              <div className="col-md-2 col-4" key={index}>
                <div className="image-card">
                  <img src={item.img} alt={item.label} className="item-image" />
                  <div className="item-label"><strong>{item.label}</strong></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="row d-block d-md-none">
          <Slider {...mobileCarouselSettings1} className="sports-carousel1">
            {sportsItems.slice(0, 9).map((item, index) => (
              <div className="item" key={index}>
                <div className="image-card">
                  <img src={item.img} alt={item.label} className="item-image" />
                  <div className="item-label"><strong>{item.label}</strong></div>
                </div>
              </div>
            ))}
          </Slider>

          <Slider {...mobileCarouselSettings2} className="sports-carousel2">
            {sportsItems.slice(9).map((item, index) => (
              <div className="item" key={index + 9}>
                <div className="image-card">
                  <img src={item.img} alt={item.label} className="item-image" />
                  <div className="item-label"><strong>{item.label}</strong></div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default FacilitySection;
